import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Wyłącz wyświetlanie błędów "Failed to connect to MetaMask"
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    if (event.message?.includes("Failed to connect to MetaMask")) {
      event.preventDefault(); // blokuje overlay Reacta
      console.debug("Silenced MetaMask window error:", event.error);
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (event.reason?.message?.includes("Failed to connect to MetaMask")) {
      event.preventDefault();
      console.debug("Silenced MetaMask promise rejection:", event.reason);
    }
  });
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);


reportWebVitals();
